// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Play_wrapper_308Tl","content":"Play_content_2RBsI","prompt":"Play_prompt_2k-fQ"};